import axios from 'axios';

/**
 * Uploads a file to S3 using a presigned URL
 *
 * @param {Object} params
 * @param {string} params.url - Presigned S3 URL
 * @param {File} params.file - File object to upload
 * @param {string} params.contentType - MIME type
 * @returns Promise<void>
 */
export const uploadToS3 = async ({ url, file, contentType }) => {
  await axios.put(url, file, {
    headers: {
      'Content-Type': contentType
    }
  });
};
